import { AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions } from '@aims/common-components';
import { Component, OnInit } from '@angular/core';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-component-report',
  templateUrl: './component-report.component.html',
  styleUrls: ['./component-report.component.css'],
})
export class ComponentReportComponent implements OnInit {

  constructor(public permissionsService: PermissionsService) {
  }

  imgSrc: string = environment.assetsPath;

  //Spinner
  spinnerText: string = "Loading";
  showSpinner: boolean = false;

  components = this.permissionsService.getComponents();
  componentsPGValues: [] = [];

  componentsPGHeader: AimsCommonTableHeader[] = [
    { key: 'type', label: 'Type', type: AimsCommonTableHeaderType.DYNAMIC, filter: false, width: 100 },
    { key: 'permissionUserOrPgName', label: 'Name', type: AimsCommonTableHeaderType.DYNAMIC,
       events: { filterAndSortCompare: (term, el) => {
       let x = (el.permissionGroupName?.toLowerCase()?.includes(term) || el.fullName?.toLowerCase()?.includes(term));
       return x;
      }} },
    { key: 'create', label: 'Create', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 },
    { key: 'read', label: 'Read', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 },
    { key: 'update', label: 'Update', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 },
    { key: 'delete', label: 'Delete', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 }
  ];
  componentsPGPermissions: AimsCommonTablePermissions = {create:false,update:false,delete:false, export:false};

  componentLookupColumns: AimsCommonTableHeader[] = [
    { key: 'component', label: 'Component', type: AimsCommonTableHeaderType.STRING },
    { key: 'description', label: 'Description', type: AimsCommonTableHeaderType.HTML },
  ];

  handleComponentLookupChange(element) {
    if (!element) {
      this.componentsPGValues = [];
    }
    else {
      this.showSpinner = true;
      let componentId = element.componentId;
      if (componentId) {
        this.permissionsService.getComponentReport(componentId).subscribe(ret => {
          this.componentsPGValues = ret;
          this.showSpinner = false;
        });
      }
    }
  }

  ngOnInit(): void {
  }

}
